import { createFileRoute } from "@tanstack/react-router";
import { useForm } from "react-hook-form";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { z } from "zod/v4";
import { zodResolver } from "@hookform/resolvers/zod";

const PaymentIdSchema = z.object({
  paymentId: z.string().min(1, { message: "Payment ID is required" }),
});

export const Route = createFileRoute("/(app)/_admin-layout/admin_/payments")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = Route.useNavigate();
  const form = useForm({
    resolver: zodResolver(PaymentIdSchema),
    defaultValues: {
      paymentId: "",
    },
  });

  const onSubmit = async (data: z.infer<typeof PaymentIdSchema>) => {
    console.log("Form submitted:", data);
    navigate({
      to: `/admin/payments/$paymentId`,
      params: { paymentId: data.paymentId },
    });
  };

  return (
    <div className="max-w-xl ">
      <div className="bg-white p-6 rounded-lg shadow-sm">
        <h1 className="text-2xl font-bold mb-4">Payment Search</h1>
        <Form {...form}>
          <form
            onSubmit={(e) => void form.handleSubmit(onSubmit)(e)}
            className="w-full"
          >
            <div className="flex-1">
              <FormField
                control={form.control}
                name="paymentId"
                render={({ field }) => (
                  <FormItem className="space-y-1">
                    <FormLabel className="font-semibold text-sm">
                      Payment ID
                    </FormLabel>
                    <FormControl>
                      <Input placeholder="Enter payment ID" {...field} />
                    </FormControl>
                    {form.formState.errors.paymentId?.message && (
                      <FormMessage />
                    )}
                  </FormItem>
                )}
              />
            </div>
            <Button type="submit" className="mb-[2px] mt-3">
              Search
            </Button>
          </form>
        </Form>
      </div>
    </div>
  );
}
